var React = require('react');

function Crdenvelope (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(2 2)","stroke":"#000","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("rect",{"x":"30","width":"66","height":"49","rx":"2","key":0}),React.createElement("path",{"d":"M50 27h26M50 32h26M50 37h26M17 23h13M0 23h8M12 23h1M27 13h3M8 13h9M22 13h1M37 6h9M37 10h9M27 33h3M13 33h4M22 33h1","key":1}),React.createElement("path",{"fill":"#7BD0E2","fillRule":"nonzero","d":"M76 5h14v14H76z","key":2})]));
}

Crdenvelope.displayName = "Crdenvelope";

Crdenvelope.defaultProps = {"width":"100","height":"53"};

module.exports = Crdenvelope;

Crdenvelope.default = Crdenvelope;
